import React from "react";
import { useState } from "react";

export const Navigation = (props) => {
  const [show, setShow] = useState(false)
  const clickService = () => {
    setShow(!show)
  }
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            Prime Financial Advisory 
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {/* <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li> */}
            <li>
              <a href="#about" className="page-scroll">
                About Us
              </a>
            </li>
            <li className="dropdown">
              <a 
                href="#" 
                className="dropdown-toggle" 
                data-toggle="dropdown" 
                role="button" 
                aria-haspopup="true" 
                aria-expanded="false"
              >
                Services <span className="caret"></span>
              </a>
              <ul className="dropdown-menu" style={{
                backgroundColor: 'rgba(10, 10, 10, 1)',
                border: 'none',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)'
              }}>
                <li><a href="#services" style={{ 
                  color: 'rgba(222, 187, 119, 1)',
                  backgroundColor: 'transparent'
                }}>Residential Loans</a></li>
                <li><a href="#services" style={{ 
                  color: 'rgba(222, 187, 119, 1)',
                  backgroundColor: 'transparent'
                }}>Commercial Loans</a></li>
                <li><a href="#services" style={{ 
                  color: 'rgba(222, 187, 119, 1)',
                  backgroundColor: 'transparent'
                }}>Asset Loans</a></li>
              </ul>
            </li>
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li> */}
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
